import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { sendInteract } from '../net/interact.js';
import { useBoardStore } from '../state/board-store.js';
import { useSessionStore } from '../state/session-store.js';

/**
 * The E menu of an object with several actions, e.g. coffee or tea (ADR-0029). Number keys pick
 * an entry, Escape closes it, and walking away from the object closes it too.
 */
export function InteractionMenu() {
  const { t } = useTranslation();
  const menu = useBoardStore((s) => s.menu);
  const targetId = useSessionStore((s) => s.interactionTarget?.objectId);
  const close = () => useBoardStore.getState().openMenu(undefined);

  useEffect(() => {
    if (menu && targetId !== menu.objectId) useBoardStore.getState().openMenu(undefined);
  }, [menu, targetId]);

  useEffect(() => {
    if (!menu) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        useBoardStore.getState().openMenu(undefined);
        return;
      }
      const choice = menu.choices[Number(event.key) - 1];
      if (choice) {
        sendInteract(menu.objectId, choice.action);
        useBoardStore.getState().openMenu(undefined);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [menu]);

  if (!menu) return null;
  return (
    <div className="hud-box interaction-menu" role="menu">
      {menu.choices.map((choice, index) => (
        <button
          key={choice.action}
          type="button"
          role="menuitem"
          className="secondary"
          onClick={() => {
            sendInteract(menu.objectId, choice.action);
            close();
          }}
        >
          <kbd>{index + 1}</kbd> {t(choice.labelKey)}
        </button>
      ))}
    </div>
  );
}
